module.exports = {
          srcSet: __webpack_public_path__ + "images/1973-ab248aae0bdb0a79a0121cf0667f2994-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1973-b782b5753c0685544d42ddd270431ff7-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1973-ab248aae0bdb0a79a0121cf0667f2994-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1973-b782b5753c0685544d42ddd270431ff7-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1973-ab248aae0bdb0a79a0121cf0667f2994-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1973-ab248aae0bdb0a79a0121cf0667f2994-320.jpg"},
          
          width: 320,
          height: 251
        }